module.exports = __webpack_public_path__ + "static/img/google-play-badge-en.b0e9220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google-play-badge-en.png
// module id = 3MKX
// module chunks = 1